import type { TokenStoreState } from "../types.js";

/**
 * In-memory only. Never backed by localStorage/sessionStorage —
 * refresh tokens must not be read or written by JS; the API may store them
 * in HttpOnly cookies. Rehydration after reload is handled by bootstrapSession().
 */
export function createTokenStore() {
  let state: TokenStoreState = { accessToken: null, refreshToken: null };

  return {
    get(): TokenStoreState {
      return state;
    },
    set(next: TokenStoreState): void {
      state = next;
    },
    clear(): void {
      state = { accessToken: null, refreshToken: null };
    },
  };
}

export type TokenStore = ReturnType<typeof createTokenStore>;
